export default __webpack_public_path__ + "static/media/logo.723375eb.svg";